// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ConfigWiseAssignee,
    ConfigWiseAssigneeFromJSON,
    ConfigWiseAssigneeToJSON,
    ConfigWiseResult,
    ConfigWiseResultFromJSON,
    ConfigWiseResultToJSON,
    TestCaseMinified,
    TestCaseMinifiedFromJSON,
    TestCaseMinifiedToJSON,
    UserMinified,
    UserMinifiedFromJSON,
    UserMinifiedToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestPlanTestCase
 */
export interface TestPlanTestCase {
    /**
     * 
     * @type {number}
     * @memberof TestPlanTestCase
     */
    id: number;
    /**
     * 
     * @type {TestCaseMinified}
     * @memberof TestPlanTestCase
     */
    testCase: TestCaseMinified;
    /**
     * This is combined status for whole Test Case across multiple configurations (old values- 0, 1, 2, 3 ,4 and new values- unexecuted, passed, failed, skipped, blocked)
     * @type {string}
     * @memberof TestPlanTestCase
     */
    status: string;
    /**
     * Time taken (in seconds)
     * @type {number}
     * @memberof TestPlanTestCase
     */
    timeTaken: number;
    /**
     * Time spent per execution
     * @type {number}
     * @memberof TestPlanTestCase
     */
    avgTimePerExec: number;
    /**
     * 
     * @type {Array<ConfigWiseResult>}
     * @memberof TestPlanTestCase
     */
    results?: Array<ConfigWiseResult>;
    /**
     * 
     * @type {Array<ConfigWiseAssignee>}
     * @memberof TestPlanTestCase
     */
    configAssignees?: Array<ConfigWiseAssignee>;
    /**
     * Last run
     * @type {Date}
     * @memberof TestPlanTestCase
     */
    lastRun?: Date;
    /**
     * 
     * @type {UserMinified}
     * @memberof TestPlanTestCase
     */
    assignedTo?: UserMinified;
    /**
     * 
     * @type {string}
     * @memberof TestPlanTestCase
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof TestPlanTestCase
     */
    updatedAt: string;
}

export function TestPlanTestCaseFromJSON(json: any): TestPlanTestCase {
    return {
        'id': json['id'],
        'testCase': TestCaseMinifiedFromJSON(json['test_case']),
        'status': json['status'],
        'timeTaken': json['time_taken'],
        'avgTimePerExec': json['avg_time_per_exec'],
        'results': !exists(json, 'results') ? undefined : (json['results'] as Array<any>).map(ConfigWiseResultFromJSON),
        'configAssignees': !exists(json, 'config_assignees') ? undefined : (json['config_assignees'] as Array<any>).map(ConfigWiseAssigneeFromJSON),
        'lastRun': !exists(json, 'last_run') ? undefined : new Date(json['last_run']),
        'assignedTo': !exists(json, 'assigned_to') ? undefined : UserMinifiedFromJSON(json['assigned_to']),
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function TestPlanTestCaseToJSON(value?: TestPlanTestCase): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'test_case': TestCaseMinifiedToJSON(value.testCase),
        'status': value.status,
        'time_taken': value.timeTaken,
        'avg_time_per_exec': value.avgTimePerExec,
        'results': value.results === undefined ? undefined : (value.results as Array<any>).map(ConfigWiseResultToJSON),
        'config_assignees': value.configAssignees === undefined ? undefined : (value.configAssignees as Array<any>).map(ConfigWiseAssigneeToJSON),
        'last_run': value.lastRun === undefined ? undefined : value.lastRun.toISOString(),
        'assigned_to': UserMinifiedToJSON(value.assignedTo),
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}


